module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjFwdCI+CiAgICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNMCAwaDUxMS45OTN2NTA0LjI5NEgweiIvPgogICAgPHBhdGggZmlsbD0iI2YxMDYwMCIgZD0iTTAgMGg1MTEuOTkzdjE2Ny44NkgweiIvPgogICAgPHBhdGggZD0iTTAgMzQ0LjEyM2g1MTEuOTkzdjE2Ny44NkgweiIvPgogIDwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/ye.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/ye.svg
// module chunks = 0